@use '@/styles/tokens' as *;

.card {
  border: 1px solid $color-neutral-100;
  border-radius: 12px;
  overflow: hidden;
  background: var(--surface-card);
}

.head {
  display: grid;
  gap: 24px;
  align-items: center;
  height: 44px;
  padding: 0 20px;
  background: #f5f4ef;
}

.body {
  display: flex;
  flex-direction: column;
}

.row {
  display: grid;
  gap: 24px;
  align-items: center;
  height: 56px;
  padding: 0 20px;
  border-bottom: 1px solid $color-neutral-100;

  &:last-child {
    border-bottom: none;
  }
}

.headCell,
.cell {
  min-width: 0;
}

// The live `th`'s type, so the titles read as the table's own. Column positions are the skeleton's
// equal-width grid, not the table's declared widths — the band can shift sideways as data arrives.
.headTitle {
  min-width: 0;
  font-size: $font-size-xs;
  font-weight: $font-weight-regular;
  color: var(--text-tertiary);
  @include truncate;
}

.bar {
  display: block;
  height: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, #eee 25%, #f5f5f5 37%, #eee 63%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;
}

.headCell .bar {
  height: 10px;
  background: linear-gradient(90deg, #e6e5df 25%, #efeee8 37%, #e6e5df 63%);
  background-size: 400% 100%;
}

@keyframes shimmer {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .bar {
    animation: none;
  }
}
